<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">Remove {{ inputItem }}?</h2>
<mat-dialog-content>
  <form class="form" [formGroup]="form">
    <mat-checkbox color="primary" formControlName="rememberIt">
      Do this automatically when all steps are complete
    </mat-checkbox>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <app-button
    [buttonColor]="'warn'"
    [buttonType]="ButtonType.STROKED"
    (clickEvent)="cancel()"
    [buttonLabel]="'Cancel'"
  ></app-button>
  <app-button [buttonType]="ButtonType.RAISED" (clickEvent)="ok()" [buttonLabel]="'Ok'"></app-button>
</mat-dialog-actions>
